import './App.css';
import Cabinet from './pages/Cabinet/Cabinet';

function App() {
  return (
    <div className="App">
      <Cabinet></Cabinet>
    </div>
  );
}

export default App;
